import React from 'react'
import Card from '@components/V3/Card'
import Pill from '@components/V3/Pill'
import Text from '@components/V3/Text'
import TextSkeleton from '@components/V3/Text/TextSkeleton'
import useInitialData from '@page-components/Layout/useInitialData'
import BigDivider from '@page-components/TrackV2/components/BigDivider'
import {useContactModalContext} from '@page-components/TrackV2/components/ContactModalContext'
import getStoreInMapLink from '@page-components/TrackV2/helpers/getStoreInMapLink'
import isCompleted from '@page-components/TrackV2/helpers/isCompleted'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'
import useStatus from '@page-components/TrackV2/hooks/useStatus'
import {useTranslation} from 'next-i18next'

export const StoreSkeleton = () => (
  <Card transparentOnDesktop desktopThreshold="lg">
    <div className="flex items-center px-4">
      <div className="flex-1">
        <TextSkeleton type="caption" className="w-1/4" />
        <TextSkeleton type="title" className="w-3/4" />
      </div>
    </div>
  </Card>
)

export default function Store() {
  const {website} = useInitialData()
  const {order} = useOrder()
  const status = useStatus()
  const {t} = useTranslation('tracking', {keyPrefix: 'store'})
  const {setOpen} = useContactModalContext()

  if (isCompleted(status)) {
    return null
  }

  if (!order.store?.address) {
    return null
  }

  return (
    <Card transparentOnDesktop desktopThreshold="lg">
      <BigDivider className="hidden lg:block" />
      <div className="flex items-center px-4">
        <a
          href={getStoreInMapLink(order.store)}
          target="_blank"
          className="flex-1"
          rel="noreferrer">
          <Text type="caption">{website.name}</Text>
          <Text type="title">{order.store?.address?.address}</Text>
        </a>
        <Pill onClick={() => setOpen(true)} small>
          {t('contact')}
        </Pill>
      </div>
    </Card>
  )
}
